import React from "react";
import { Card, Columns, Stack, Text } from "@shopify/polaris";
import { Field } from "react-final-form";
import ActionField from "../../StockTypeAndOptions/components/ActionField.js";
import NotifySection from "../../StockTypeAndOptions/components/NotifySection/NotifySection.js";

import {
  PRODUCTS_ACTION_HIDE,
  PRODUCTS_ACTION_PUSH_DOWN,
  PRODUCTS_NO_ACTION
} from "../../../../../../../../constants/productActionTypes.js";

const actionOptions = [
  { label: "Hide products", value: PRODUCTS_ACTION_HIDE },
  { label: "Push down products", value: PRODUCTS_ACTION_PUSH_DOWN },
  { label: "No action", value: PRODUCTS_NO_ACTION }
];

const BasedOnAttributesCard = () => {
  return (
    <Card>
      <Card.Section>
        <Columns columns={{ xs: "1fr 1fr" }}>
          <Stack distribution={"fill"} vertical>
            <Field name="basedOnAttributesAction" component={ActionField} options={actionOptions} />
            <Field name="attributesActions" component={NotifySection} />
          </Stack>
        </Columns>
      </Card.Section>
    </Card>
  );
};

export default BasedOnAttributesCard;
